import { axiosObject } from "../config";
import { webStore } from "store";


function getBankBranchesByid(branchIds: any) {
    return new Promise((resolve, reject) => {
        const bankData: any = webStore.getState().bankerAuth.bank;
        let uri = "auction/data/resource/bank-branches/_read";
        let payload = {
            filterBy: [
                { attribute: "uuid", op: "in", value: branchIds }
            ],
        };

        if (bankData && bankData.uuid) {
            payload.filterBy.push({ attribute: "bank_uuid", op: "eq", value: bankData.uuid },)
        }

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function getBankBranchByIfsc(ifsc: any) {
    return new Promise((resolve, reject) => {
        let uri = "auction/data/resource/bank-branches/_read";
        let payload = {
            filterBy: [
                { attribute: "ifsc", op: "eq", value: ifsc }
            ],
        };

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data.data[0]);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

export { getBankBranchesByid, getBankBranchByIfsc };
